import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleParty } from '../../../Store/PHPSlice/Party';
import { deleteStudents } from '../../../Store/PHPSlice/zone';
import { sendwhatsappMsg } from '../../../Store/PHPSlice/sendWhatsappMsg'

const TableBody3 = ({
    serialNumber,
    id,
    schoolNm,
    studNm,
    age,
    std,
    div,
    ph,
    schlId,
    schlcd,
    schlNm,
    zoneId,
    zoneNm,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/student-edit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleCheckboxChange = (event, checked, serialNumber) => {
        console.log("Row ID:", ` ${id}`, "Checked:", checked);
        // you can update state, dispatch redux, etc.
        sendwhatsappMsg(id);
    };
    const sendwhatsappMsg = (id) => {
        console.log("Sending WhatsApp message for ID:", id);
        // your API call / logic here
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete the Student?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteStudents(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Cloth Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }
    };



    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {/* <Checkbox sx={{ p: 1 }}
                        onChange={(e) => handleClick(e)}
                    /> */}

                    {serialNumber}

                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {zoneNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {schoolNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {studNm}
                </TableCell>



                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {age}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {std}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {div}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {ph}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default TableBody3;
